import { render, staticRenderFns } from "./LinkTenantSettingListUser.vue?vue&type=template&id=1b86ed7f&scoped=true"
import script from "./LinkTenantSettingListUser.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingListUser.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingListUser.vue?vue&type=style&index=0&id=1b86ed7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b86ed7f",
  null
  
)

export default component.exports